import { render, staticRenderFns } from "./HeaderType1.vue?vue&type=template&id=3f231f68&scoped=true&lang=pug&"
import script from "./HeaderType1.vue?vue&type=script&lang=ts&"
export * from "./HeaderType1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f231f68",
  null
  
)

export default component.exports